import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export default function LabelSwitch({
  options = [
    {
      id: 'customer',
      label: 'Customer'
    },
    {
      id: 'owner',
      label: 'PPA Owner'
    }
  ],
  onChange = (event, value) => {
    console.log(event, value);
  }
}) {
  const [checked, setChecked] = useState(false);
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography
        sx={{
          textTransform: 'initial',
          color: checked
            ? theme.palette.text.disabled
            : theme.palette.text.primary,
          transition: theme.transitions.create(['color'])
        }}
        variant="body1"
      >
        {options[0].label}
      </Typography>
      <Switch
        size="small"
        onChange={(event, checked) => {
          setChecked(checked);
          onChange(event, checked ? options[1] : options[0]);
        }}
        checked={checked}
        color="default"
      />
      <Typography
        sx={{
          textTransform: 'initial',
          color: checked
            ? theme.palette.text.secondary
            : theme.palette.text.disabled,
          transition: theme.transitions.create(['color'])
        }}
        variant="body1"
      >
        {options[1].label}
      </Typography>
    </Stack>
  );
}
